module.exports = __webpack_public_path__ + "img/icon-question.36fdefb9.gif";